import React from 'react';

const QuitterSvg = ({width = 20, height = 20}) => (
    <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.66699" y="2.33203" width="14.6667" height="16.3333" stroke="#002335" strokeWidth="2"/>
        <path d="M10.3701 14.418L6.45472 10.5026L10.3789 6.57834" stroke="#002335" strokeWidth="2"/>
        <path d="M6.8125 10.4922L14.5497 10.4835" stroke="#002335" strokeWidth={2}/>
    </svg>
);

export default QuitterSvg;
